import style from './index.module.scss';
import clsx from 'clsx';
import HeaderButton from '../HeaderButton';
import NavMenu from '../NavMenu';

function MenuMobile({ isOpen, menu, text, link ,currentPage}) {
    return (
        <div className={clsx(style.menu, isOpen && style.open)}>
            <nav className={style.content}>
                <NavMenu menu={menu} currentPage={currentPage}/>
                <HeaderButton text={text} link={link} />
            </nav>
        </div>
    );
}

export default MenuMobile;
